<template>
    <nav class="navbar navbar-expand-lg navbar-dark sticky-top">
        <router-link class="navbar-brand" to="/"><img src="../assets/img/logo-akanea-blanc-transparent.webp" class="logo-akanea" alt=""></router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
        
            <li class="nav-item xs-hidden">
                <router-link class="nav-link" to="/">{{ $t('nav.home') }}</router-link>
            </li>
            
            <li class="nav-item dropdown xs-hidden">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ $t('nav.solutions') }} <span class="sr-only">(current)</span>
                </a>
                <div class="dropdown-menu shadowed" aria-labelledby="navbarDropdown">
                    <router-link class="dropdown-item" to="/solutions/fleet"><img src="../assets/img/Fleet.png" class="mr-2" alt="iconLogistics"><div><strong>{{ $t('nav.fleet') }}</strong> <div class="light">{{ $t('nav.fleetSub') }}</div></div></router-link>
                    <!-- <router-link class="dropdown-item" to="/solutions/digitappro"><img src="../assets/img/DigitAppro.png" class="mr-2" alt="iconMarketplace"><div><strong>{{ $t('nav.dap') }}</strong> <div class="light">{{ $t('nav.dapSub') }}</div></div></router-link>
                    <router-link class="dropdown-item" to="/solutions/novacollecte"><img src="../assets/img/NovaCollecte.png" class="mr-2" alt="iconMarketplace"><div><strong>{{ $t('nav.nova') }}</strong> <div class="light">{{ $t('nav.novaSub') }}</div></div></router-link>
                    <router-link class="dropdown-item" to="/solutions/echangesemences"><img src="../assets/img/BourseEchange.png" class="mr-2" alt="iconBoursedechange"><div><strong>{{ $t('nav.echag') }}</strong> <div class="light">{{ $t('nav.echagSub') }}</div> </div></router-link> -->
                    <!-- <router-link class="dropdown-item" to="/solutions/marketplace"><img src="../assets/img/iconMarketplace.png" class="mr-2" alt="iconMarketplace">MarketPlace - eCommerce</router-link> -->
                    <!-- <router-link class="dropdown-item" to="/"><img src="../assets/img/iconOccasion.png" class="mr-2" alt="iconAnnonces">Petites annonces</router-link> -->
                    <!-- <div class="dropdown-divider"></div>
                    <router-link class="dropdown-item" to="/"><img src="../assets/img/iconSurmesure.png" class="mr-2" alt="iconSurmesure">Sur mesure</router-link> -->
                </div>
            </li>
 
            <!-- <li class="nav-item xl-hidden">
                <router-link data-toggle="collapse" data-target="#navbarSupportedContent" to="/solutions/digitappro" class="mobileMenuItem"><img src="../assets/img/DigitAppro.png" class="mr-2" alt="iconMarketplace"><div class="light"><strong>{{ $t('nav.dap') }}</strong> <br> {{ $t('nav.dapSub') }}</div></router-link>
            </li>
            <li class="nav-item xl-hidden">
                <router-link data-toggle="collapse" data-target="#navbarSupportedContent" to="/solutions/novacollecte" class="mobileMenuItem"><img src="../assets/img/NovaCollecte.png" class="mr-2" alt="iconMarketplace"><div class="light"><strong>{{ $t('nav.nova') }}</strong> <br>   {{ $t('nav.novaSub') }}</div></router-link>
            </li> -->
            <li class="nav-item xl-hidden">
                <router-link data-toggle="collapse" data-target="#navbarSupportedContent" to="/solutions/fleet" class="mobileMenuItem"><img src="../assets/img/Fleet.png" class="mr-2" alt="iconLogistics"><div class="light"><strong>{{ $t('nav.fleet') }}</strong> <br> {{ $t('nav.fleetSub') }}</div></router-link>
            </li>
            <!-- <li class="nav-item xl-hidden">
                <router-link data-toggle="collapse" data-target="#navbarSupportedContent" to="/solutions/echangesemences" class="mobileMenuItem"><img src="../assets/img/BourseEchange.png" class="mr-2" alt="iconBoursedechange"><div class="light"><strong>{{ $t('nav.echag') }}</strong> <br> {{ $t('nav.echagSub') }}</div> </router-link>
            </li> -->
            <li class="nav-item">
                <router-link  class="nav-link" to="/agrivitechpourleclimat"> {{ $t('nav.impact') }} </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/apropos"> {{ $t('nav.about') }} </router-link>
            </li>
            <!-- <li class="nav-item">
                <router-link class="nav-link" to="/jobs"> {{ $t('nav.jobs') }} </router-link>
            </li> -->
            <!-- <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    A propos
                </a>
                <div class="dropdown-menu shadowed" aria-labelledby="navbarDropdown">
                    <router-link class="dropdown-item" to="/apropos"><img src="../assets/img/Path.png" class="mr-2" alt="iconAgrivitech">Agrivitech</router-link>
                    <a class="dropdown-item" href="#"><img src="../assets/img/iconmonstr-handshake-2.png" class="mr-2" alt="iconClient">Clients</a>
                    <router-link class="dropdown-item" to="/jobs"><img src="../assets/img/iconmonstr-briefcase-5.png" class="mr-2" alt="iconClient">Emploi</router-link>
                </div>
            </li> -->
            <!-- <li class="nav-item xs-hidden">
                <router-link class="nav-link" to="/actualites">{{ $t('nav.news') }}</router-link>
            </li> -->
            <li class="nav-item xs-hidden">
                <router-link class="nav-link  btn-nav" to="/contact">{{ $t('nav.contactUs') }}</router-link>
            </li>
            <li class="nav-item xs-hidden">
                <router-link class="nav-link"  to="/private">{{ $t('nav.private') }}</router-link>        
            </li>
   
            <!-- <select class="form-control langSelect"  v-model="$root.$i18n.locale">
                <option  v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang.code">
                    {{ lang.img }}
                </option>
            </select> -->
         
            </ul>
        </div>
    </nav>
</template>

<script>
import router from '@/router/router'
import { store } from '@/router/store'


export default {
  data() {
    return {
          langs: [ 
            {
                code: 'fr',
                img: "FR"
            },
            {
                code: 'en',
                img: "EN"
            },
            ] 
    };
  },
  computed: {
      userName () {
        return store.state.user.company
     },
  },
  methods: {
    logout() {
        this.isLoggedIn = false
        this.username = '',
        this.secretMessage = '';
        router.push('/login');
    },

  }
};
</script>


<style lang="scss" scoped>


nav.navbar.navbar-dark{
    background-color: var(--mainBlue);
    a {
        color: white;
    }
    .langSelect{
        margin-top: 3px;
        max-width: fit-content;
        background-color: transparent;
        color: #f9f9f9;
        border: none;
        font-size: 12px;
        font-weight: 600;
        &:focus{
            border: none;
        }
        option{
            color: var(--mainBlue);
        }
        
    }
    .btn-nav{
        background-color: white;
        color: var(--mainBlue);
        border-radius: 5px;
        padding: 10px 30px;
        &:hover{
          background-color: var(--mainGreen);
          color: white;
        }
    }
    @media (min-width: 576px) { 

        a{
            margin: 0px 20px;
        }
        .xs-hidden{

        }
        .xl-hidden{
            display: none;
        }
     }
     @media (max-width: 576px) { 
        .xs-hidden{
            display: none;
        }
        .xl-hidden{
            .mobileMenuItem{
                display: flex;
                align-items: center;
                padding: 15px 0px;
                color: white;
            }
            img{
                max-width: 40px;
                max-height: 40px;
            }
        }
     }
     .logo-akanea{
        width: 170px;
     }
    .dropdown {
        .dropdown-menu {
            // border-radius: 20px;
            padding: 0px 10px;
            .dropdown-item {
                color: var(--mainBlue);
                font-size: 14px;
                padding: 5px;
                margin: 10px 0px;
                border: none;
                display: flex;
                // min-width: 200px;
                .light{
                    font-size: 12px;
                    font-weight: 500;
                    color: gray;
                }
                img{
                    max-width: 40px;
                    max-height: 40px;
                }
                &:hover{
                    background-color: #f9f9f9;
                    color: var(--mainGreen);
                    border-radius: 10px;
                }
                &.active {
                    border:none;
                } 
            }
        }
    }
}

</style>